module.exports = __webpack_public_path__ + "img/subtract.f08db822.svg";